module.exports = __webpack_public_path__ + "OpenSans-Regular-ac327c4db6284ef64ebe872b6308f5da.woff";